import actions from '../../actionTypes';

export default payload => {
  return {
    type: actions.ADD_INFO,
    error: false,
    payload
  };
};



// WEBPACK FOOTER //
// ./src/reducers/notifications/actions/addInfo.js